import React from "react";
import "./Skeleton.css";

export function SkeletonLine({ width = "100%", height = "1rem", className = "" }) {
  return (
    <div
      className={`skeleton-shimmer ${className}`.trim()}
      style={{
        width,
        height,
        borderRadius: 4,
      }}
    />
  );
}

export function CardSkeleton() {
  return (
    <div className="card">
      <div className="card-header">
        <SkeletonLine width="40%" height="1.25rem" />
      </div>
      <div className="card-body">
        <SkeletonLine width="100%" className="mb-3" />
        <SkeletonLine width="90%" className="mb-3" />
        <SkeletonLine width="70%" className="mb-3" />
        <SkeletonLine width="95%" />
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 5, cols = 4 }) {
  return (
    <div className="ReactTable -striped -highlight">
      <div className="mb-3">
        <SkeletonLine width="200px" height="38px" />
      </div>
      <table className="rt-table">
        <thead className="rt-thead -header">
          <tr className="rt-tr">
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="rt-th text-left">
                <SkeletonLine width={i === 0 ? "60%" : "40%"} height="1rem" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="rt-tbody">
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx} className="rt-tr">
              {Array.from({ length: cols }).map((_, colIdx) => (
                <td key={colIdx} className="rt-td">
                  <SkeletonLine
                    width={colIdx === 0 ? "70%" : "50%"}
                    height="0.875rem"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CardSkeleton;
